import { useEffect, useState } from 'react';
import { useGlobalStore } from '@/stores';
import {
    AnalyticsDateRangePicker,
    AnalyticsMetricsSection,
    PageTrafficChart,
    ProductAnalyticsTable,
    TrafficSourcesChart,
} from '@/features/analytics';
import { CHART_TYPES, type DateRangeObject } from '@/features/analytics/types/analytics.types';
import { RANGE_TYPES } from '@/features/analytics/constants/analytics.constants';

export default function AnalyticsPage() {
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);

    const [dateRange, setDateRange] = useState<DateRangeObject>({
        startDate: new Date(new Date().setDate(new Date().getDate() - 14)),
        endDate: new Date(),
        rangeType: RANGE_TYPES.LAST_14_DAYS,
    });

    useEffect(() => {
        setBreadcrumbs([{ title: 'Analytics', to: '/analytics', active: true, id: 'analytics' }]);
    }, [setBreadcrumbs]);

    return (
        <div className='flex w-full flex-col gap-6'>
            <AnalyticsDateRangePicker onRangeSelected={setDateRange} />

            <AnalyticsMetricsSection dateRange={dateRange} initialChart={CHART_TYPES.LEADS} />

            <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
                <TrafficSourcesChart dateRange={dateRange} />
                <PageTrafficChart dateRange={dateRange} />
            </div>

            <ProductAnalyticsTable dateRange={dateRange} />
        </div>
    );
}
